import clsx from "clsx"
import Slider from "react-slick"

const HeroSlider = ({ settings, slides, text1 = false, title, subtitle }) => {
  return (
    <>
      <Slider {...settings} className="h-[calc(100vh-16px)]">
        {slides.map((s, i) => (
          <div key={i} className={clsx("h-[calc(100vh-16px)] bg-cover bg-center bg-no-repeat", s)}></div>
        ))}
      </Slider>
      {text1 && (
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2">
          <h1 className="text-white text-center font-light">
            <span className="uppercase font-agcasmlt text-5xl sm:text-6xl lg:text-7xl">{title}</span>
            <span className="capitalize font-sloopScriptPro block text-2xl md:text-3xl">{subtitle}</span>
          </h1>
        </div>
      )}
    </>
  )
}

export default HeroSlider